const PERSONNUMMER_REGEX = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+-]?)(?!000)(\d{3})(\d)$/;

const luhn = (str: string): number => {
  let sum = 0;
  for (let i = 0; i < str.length; i++) {
    let v = parseInt(str[i]) * (2 - (i % 2));
    if (v > 9) v -= 9;
    sum += v;
  }
  return Math.ceil(sum / 10) * 10 - sum;
};

const isValidDate = (year: number, month: number, day: number): boolean => {
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

const parse = (pin: string) => {
  if (pin.length < 10 || pin.length > 13) return null;

  const match = PERSONNUMMER_REGEX.exec(pin);
  if (!match) return null;

  let century = match[1];
  const year = match[2];
  const month = match[3];
  const day = match[4];
  const sep = match[5];
  const num = match[6];
  const check = match[7];

  if (!century) {
    const now = new Date();
    const baseYear = sep === '+' ? now.getFullYear() - 100 : now.getFullYear();
    century = String(baseYear - ((baseYear - parseInt(year)) % 100)).substring(0, 2);
  }

  const fullYear = parseInt(century + year);
  const numericDay = parseInt(day);

  // Luhn validation on YYMMDD + NNN (10 digits)
  const luhnInput = year + month + day + num;
  if (luhn(luhnInput) !== parseInt(check)) return null;

  // Validate date (also allow coordination numbers where day += 60)
  const isRegularDate = isValidDate(fullYear, parseInt(month), numericDay);
  const isCoordinationDate = isValidDate(fullYear, parseInt(month), numericDay - 60);
  if (!isRegularDate && !isCoordinationDate) return null;

  const ageDay = isCoordinationDate && !isRegularDate ? numericDay - 60 : numericDay;

  return { century, year, month, day: ageDay, fullYear };
};

export const isValidPersonnummer = (pin: string): boolean => parse(pin) !== null;

export const getAgeFromPersonnummer = (pin: string): number => {
  const parsed = parse(pin);
  if (!parsed) return -1;

  const birthDate = new Date(parsed.fullYear, parseInt(parsed.month) - 1, parsed.day);
  const now = new Date();

  let age = now.getFullYear() - birthDate.getFullYear();
  const monthDiff = now.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
